import type { ChartLabelFormat } from './types';

const NULL_LABEL = '—';
const LOCALE = 'en-US';
const CURRENCY_CODE = 'USD';
const NUMBER_MAX_FRACTION_DIGITS = 2;
const PERCENT_MAX_FRACTION_DIGITS = 2;
const CURRENCY_FRACTION_DIGITS = 2;

const NUMBER_FORMATTER = new Intl.NumberFormat(LOCALE, {
  maximumFractionDigits: NUMBER_MAX_FRACTION_DIGITS,
});

const PERCENT_FORMATTER = new Intl.NumberFormat(LOCALE, {
  maximumFractionDigits: PERCENT_MAX_FRACTION_DIGITS,
});

const CURRENCY_INTEGER_FORMATTER = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: CURRENCY_CODE,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const CURRENCY_FRACTION_FORMATTER = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: CURRENCY_CODE,
  minimumFractionDigits: CURRENCY_FRACTION_DIGITS,
  maximumFractionDigits: CURRENCY_FRACTION_DIGITS,
});

/** Formats a numeric value for display as a chart label. */
export const formatValue = (
  value: number | null,
  format: ChartLabelFormat
): string => {
  if (value === null || !Number.isFinite(value)) {
    return NULL_LABEL;
  }

  switch (format) {
    case 'currency':
      return Number.isInteger(value)
        ? CURRENCY_INTEGER_FORMATTER.format(value)
        : CURRENCY_FRACTION_FORMATTER.format(value);
    case 'percent':
      return `${PERCENT_FORMATTER.format(value)}%`;
    case 'number':
    default:
      return NUMBER_FORMATTER.format(value);
  }
};
